import { Dispatch, useState } from 'react';

import { DateRange, DateRangeField } from '@rover/types/src/datetime/DateRange';

export type DateHooks = DateRange & {
  setStartDate: Dispatch<any>;
  setEndDate: Dispatch<any>;
};

const useDates = (min?: DateRangeField, max?: DateRangeField): DateHooks => {
  const [startDate, setStartDate] = useState(min);
  const [endDate, setEndDate] = useState(max);
  return { startDate, setStartDate, endDate, setEndDate };
};

export default useDates;
